import { useEffect } from 'react';

export const useBodyLock = (lock = true) => {
  useEffect(() => {
    if (lock) {
      const originalStyle = window.getComputedStyle(document.body).overflow;
      document.body.style.overflow = 'hidden';
      return (): void => {
        document.body.style.overflow =
          originalStyle === 'hidden' ? '' : originalStyle;
      };
    }

    return;
  }, [lock]);
};
